import * as request from '@/utils/request'
const BASE_URL = 'api'
export default {

  /**
   * @description 菜单 新增
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
   createMenu(data){
    return request.post(`${BASE_URL}/menu/store`, data)
   },

   /**
   * @description 菜单 编辑
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  updateMenu(id, data) {
    return request.put(`${BASE_URL}/menu/update/${id}`, data)
  },

  /**
   * @description 菜单 列表
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getMenuList(data) {
    return request.get(`${BASE_URL}/menu/list`, data)
  },

  /**
   * @description 菜单 详情
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  viewMenu(data) {
    return request.get(`${BASE_URL}/menu/view/${data}`)
  },

  /**
   * @description 菜单 菜单的拖拽排序
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  orderMenu(data) {
    return request.post(`${BASE_URL}/menu/order`, data)
  },

  /**
   * @description 菜单 删除菜单
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  deleteMenu(data) {
    return request.Delete(`${BASE_URL}/menu/delete/${data}`)
  },

  /**
   * @description 获取权限列表，创建菜单需要配置权限
   * @author YM
   * @date 2019-01-17
   * @returns promise
   */
  getPermissionsList() {
    return request.Delete(`${BASE_URL}/menu/permissions_list`)
  }






  // /**
  //  * @description 获取菜单列表
  //  * @author YM
  //  * @date 2019-01-17
  //  * @returns promise
  //  */
  // getMenuList() {
  //   return request.post('/menu/list')
  // },
  // /**
  //  * @description 获取权限列表
  //  * @author YM
  //  * @date 2019-01-19
  //  * @returns promise
  //  */
  // getMenuPermissionsList() {
  //   return request.post('/menu/permissions_list')
  // },
  // /**
  //  * @description 保存菜单，新建、编辑的保存都走此方法，却别是有没有主键id
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // saveMenu(data) {
  //   return request.post('/menu/store',data)
  // },
  // /**
  //  * @description 根据id获取单条信息，编辑使用
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // getMenuInfo(id) {
  //   let data = {id:id}
  //   return request.post('/menu/get_info',data)
  // },
  // /**
  //  * @description 根据id删除单条信息
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // deleteMenu(id) {
  //   let data = {id:id}
  //   return request.post('/menu/delete',data)
  // },
  // /**
  //  * @description 相同层级菜单排序
  //  * @author YM
  //  * @date 2019-01-19
  //  * @param {*} data
  //  * @returns
  //  */
  // orderMenu(ids) {
  //   let data = {ids:ids}
  //   return request.post('/menu/order',data)
  // },

}